/**
 * Web Push VAPID public key — must match Kjuup-BE `config/webpush.js`.
 * This is a public key (safe to ship in the client bundle).
 */
module.exports = {
  vapidPublicKey:
    "BDzwxrwHBsB2VEysbBjGEc-AXwTy-o9GdWPJszSIq4BmIdmlZi3iJ4wLfc10mHvQfCMgon5CIDKKN9XXYXpFml4",
};
